import meJsEnabled from "basicScripts/js-enabled";
import meMagnificPopup from "projectScripts/init-magnific-popup";

$( document ).ready( function() {
    let magnificPopup = new meMagnificPopup();

    // Add class js, remove class no-js from html-tag
    meJsEnabled();

    // Init magnific popup
    magnificPopup.init();
} );


// WEBPACK FOOTER //
// ../htdocs/web/typo3conf/ext/vero/Resources/Public/JavaScript/Src/index.js